export default __webpack_public_path__ + "static/media/home-decor-img-10.a693df87.jpg";